import Component from "./events";
import { bindActionCreators } from "redux";
import { getEvents } from "../../store/actions/events";
import { getUserProfile } from "../../store/actions/user";
import connect from "react-redux/es/connect/connect";

function mapStateToProps(state) {
  const {events,user} = state;
  return {
    events,
    user
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({ getEvents, getUserProfile }, dispatch);
}

export const Events = connect(mapStateToProps, mapDispatchToProps)(Component);
